export function circleModelPath(teamId: string, circleId: string, roleId?: string): string {
  const params = new URLSearchParams({ team: teamId, circle: circleId })
  if (roleId) {
    params.set('role', roleId)
  }
  return `/teams/circles?${params.toString()}`
}
